import { ApolloClient } from '@apollo/client'
import { CartItemInput } from 'global-graphql-types'

import {
  CartUpdateItem,
  CartUpdateItemVariables,
  CartUpdateItemDocument
} from './types/CartUpdateItem'

type Args = {
  cartUuid: string
  item: CartItemInput
  itemIndex: number
  client: ApolloClient<object>
}

export default function updateItem({
  cartUuid,
  item,
  itemIndex,
  client
}: Args) {
  return client.mutate<CartUpdateItem, CartUpdateItemVariables>({
    mutation: CartUpdateItemDocument,
    variables: { cartUuid: cartUuid!, item, itemIndex },
    refetchQueries: ['CheckoutCartQuery']
  })
}
